module.exports = __webpack_public_path__ + "33ef7a62ea66886aa79581d6e8768f8c.pdf";